import "./Roles.css";
import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { PiUserCheck } from "react-icons/pi";
import TableMui from "../../../components/table/TableMui";
import AddIcon from "@mui/icons-material/Add";
import { Form, Row, Col } from "react-bootstrap";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import ButtonCom from "../../../components/button/button";
import { AgGridReact } from "ag-grid-react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchData,
  saveRole,
  initRoleState,
} from "../../../redux/slices/roleSlice";
import {
  commonSaveData,
  commonGetDataFourth,
  initCommonState,
  commonSaveDataOne,
} from "../../../redux/slices/commonSlice";
import {
  updateRolesPath,
  deleteRolesPath,
  getEmployeeListPath,
  saveSettingsRolePermissionsPath,
} from "../../../services/config";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import CustomPagination from "../../../components/CustomPagination";
import { HasPermission } from "../../../services/hasPermission";

const paginationPageSize = 10;
const paginationPageSizeSelector = [10, 20, 50, 100];

const Roles = () => {
  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : [];
  const dispatch = useDispatch();

  const state = useSelector((state) => state.roles);
  const commonState = useSelector((state) => state.common);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [roleList, setRoleList] = useState([]);
  const [roles, setRoles] = useState({
    userId: user?.user_id,
    roleId: null,
    roleName: "",
  });

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setRoles("");
    setValidated(false);
    setOpen(false);
  };

  const getRoleList = useCallback(() => {
    dispatch(fetchData());
  }, []);

  useEffect(() => {
    getRoleList();
  }, []);

  useEffect(() => {
    if (state.roleGetSuccess) {
      setRoleList(state.roleGetData);
    }
    if (state.roleGetError) {
      toast.error(state.roleGetMessage);
    }
  }, [state.roleGetSuccess, state.roleGetError]);

  const handelChange = (e) => {
    const { value } = e.target;
    setRoles({
      ...roles,
      roleName: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      dispatch(saveRole(roles));
    }
  };

  useEffect(() => {
    if (state.roleSuccess) {
      toast.success(state.roleMessage);
      handleClose();
      setRoles({
        ...roles,
        roleName: "",
      });
      dispatch(initRoleState());
      getRoleList();
    }
    if (state.roleError) {
      toast.error(state.roleMessage);
      handleClose();
      setRoles({
        ...roles,
        roleName: "",
      });
      dispatch(initRoleState());
    }
  }, [state.roleSuccess, state.roleError]);

  // Assign role to employee is starts from here
  const [employeeList, setEmployeeList] = useState([]);
  const [filterEmployeeList, setFilterEmployeeList] = useState([]);
  const [selectIs, setSelectIs] = useState(true);

  const [searchQuery, setSearchQuery] = useState("");
  const [outletName, setOutletName] = useState("");
  const [roleId, setRoleId] = useState("");
  const [accessLevel, setAccessLevel] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);

  const handleModalClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleModalClose1 = () => {
    setShow1(false);
    setAccessLevel([]);
  };

  // Assign role to employee ------------------------------
  const getEmployeeList = useCallback((roleId) => {
    const data = {
      path: getEmployeeListPath,
      data: {
        userId: user.user_id,
        roleId: roleId,
      },
    };
    dispatch(commonSaveDataOne(data));
  }, []);

  const handleAssignId = (data) => {
    setRoleId(data.roleId);
    setOutletName(data.rolename);
    getEmployeeList(data.roleId);
    setTimeout(() => {
      handleShow1();
    }, 500);
  };

  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    if (checked) {
      const allStaff = employeeList.map((emp) => ({ staffId: emp.staffId }));
      setAccessLevel(allStaff);
    } else {
      setAccessLevel([]);
    }
  };

  const handleSelectIndividual = (staffId, checked) => {
    setAccessLevel((prev) => {
      const exists = prev.find((item) => item.staffId === staffId);
      if (checked) {
        if (!exists) {
          return [...prev, { staffId }];
        }
      } else {
        return prev.filter((item) => item.staffId !== staffId);
      }
      return prev;
    });
  };

  const handleAccessChange = (staffId, type, checked) => {
    setAccessLevel((prev) => {
      let updated = [...prev];
      const entry = updated.find((item) => item.staffId === staffId);

      // अगर पहले staffId नहीं है, तो उसे ऐड करेंगे
      if (!entry && checked) {
        updated.push({ staffId, accessType: type });
        return updated;
      }

      if (entry) {
        // AccessType अपडेट करेंगे
        if (type === "web") {
          if (entry.accessType === "mobile" && checked) {
            entry.accessType = "both";
          } else if (entry.accessType === "both" && !checked) {
            entry.accessType = "mobile";
          } else if (checked) {
            entry.accessType = "web";
          } else if (!checked && entry.accessType === "web") {
            updated = updated.filter((item) => item.staffId !== staffId);
          }
        }

        if (type === "mobile") {
          if (entry.accessType === "web" && checked) {
            entry.accessType = "both";
          } else if (entry.accessType === "both" && !checked) {
            entry.accessType = "web";
          } else if (checked) {
            entry.accessType = "mobile";
          } else if (!checked && entry.accessType === "mobile") {
            updated = updated.filter((item) => item.staffId !== staffId);
          }
        }
      }
      return updated;
    });
  };

  const isStaffSelected = (staffId) =>
    accessLevel.some((entry) => entry.staffId === staffId);

  const isChecked = (staffId, type) => {
    const item = accessLevel.find((entry) => entry.staffId === staffId);
    if (!item) return false;
    if (item.accessType === "both") return true;
    return item.accessType === type;
  };

  const handleAssignRoleSubmit = (e) => {
    e.preventDefault();
    const data = {
      path: saveSettingsRolePermissionsPath,
      data: {
        userId: user.user_id,
        roleId,
        accessLevel,
      },
    };
    dispatch(commonSaveData(data));
  };
  // ---------------------------------------------------

  const searchEmployees = (val) => {
    setSearchQuery(val);
    const filteredEmployees = filterEmployeeList.filter((v) =>
      v.fullName.toLowerCase().includes(val.toLowerCase())
    );
    setEmployeeList(filteredEmployees);
  };

  // Assign role to employee is end here

  const handleShow1 = () => setShow1(true);

  // Edit --------------------------------------
  const [isEdit, setIsEdit] = useState(false);
  const handleEdit = (row) => {
    setIsEdit(true);
    setRoles({
      ...roles,
      roleId: row.roleId,
      roleName: row.rolename,
    });
    handleClickOpen();
  };
  const handleEditSubmit = (e) => {
    e.preventDefault();
    let d = {
      path: updateRolesPath,
      data: {
        userId: user?.user_id,
        roleId: roles.roleId,
        roleName: roles.roleName,
      },
    };
    dispatch(commonSaveData(d));
  };
  // Edit --------------------------------------
  // Delete Start ------------------------------
  const [delId, setDelId] = useState(null);
  const handleDelete = (row) => {
    setDelId(row.roleId);
    handleShow();
  };
  const handleDeleteSubmit = () => {
    let d = {
      path: deleteRolesPath,
      data: {
        userId: user?.user_id,
        roleId: parseInt(delId),
      },
    };
    dispatch(commonSaveData(d));
    handleModalClose();
  };
  // Delete Ends ------------------------------
  useEffect(() => {
    if (commonState.commonSuccess) {
      toast.success(commonState.commonMessage);
      setOpen(false);
      getRoleList();
      handleModalClose1();
      setIsEdit(false);
      setDelId(null);
      dispatch(initCommonState());
    }
    if (commonState.commonError) {
      toast.error(commonState.commonMessage);
      setOpen(false);
      getRoleList();
      setIsEdit(false);
      setDelId(null);
      dispatch(initCommonState());
    }
    if (commonState.commonSuccessOne) {
      setEmployeeList(commonState.commonDataOne);
      setFilterEmployeeList(commonState.commonDataOne);
      const initiallySelected = commonState.commonDataOne
        .filter((row) => row.status === "Assigned")
        .map((row) => {
          return { staffId: row.staffId, accessType: row.accessType };
        });
      setAccessLevel(initiallySelected);
      dispatch(initCommonState());
    }
  }, [commonState, dispatch]);

  const heading = [
    {
      headerName: "Role",
      field: "rolename",
      flex: 1,
    },
    {
      headerName: "Status",
      field: "status",
      cellRenderer: (rowData) => {
        return rowData.data.status == 1 ? "Active" : "InActive";
      },
    },
    {
      headerName: "Action",
      // width: 150,
      cellRenderer: (rowData) => {
        return (
          <div className="Department-table-button">
            {/* <MdOutlineAssignmentTurnedIn
              style={{
                cursor: "pointer",
                fontSize: 25,
                color: "#58d68d",
                marginRight: "10px",
              }}
              onClick={() => {
                handleAssignId(rowData.data);
              }}
            /> */}
            {HasPermission("Roles", "edit") && (
              <PiPencilSimpleLineBold
                style={{ cursor: "pointer", fontSize: 30, color: "blue" }}
                onClick={() => {
                  handleEdit(rowData.data);
                }}
              />
            )}

            {HasPermission("Roles", "delete") && (
              <RiDeleteBinLine className="delete-icon"
                style={{ cursor: "pointer", fontSize: 30, color: "red" }}
                onClick={() => handleDelete(rowData.data)}
              />
            )}

            {!HasPermission("Roles", "edit") &&
              !HasPermission("Roles", "delete") &&
              "-"}
          </div>
        );
      },
    },
  ];

  return (
    <div
      className="SettingBody"
      style={{
        position: "fixed",
        width: "calc(100%)",
        height: "100%",
        borderRadius: "7px",
        overflow: "auto",
        backgroundColor: "transparent",
      }}
    >
      <Modal show={show} onHide={handleModalClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Delete Role</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure! to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "gray",
              color: "#fff",
              marginRight: "5px",
            }}
            onClick={handleModalClose}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "red", color: "#fff" }}
            onClick={handleDeleteSubmit}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      {/* ------------------------------ */}
      <Modal show={show1} onHide={handleModalClose1} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              display: "flex",
              flexDirection: "column",
              // alignItems: "center",
              gap: "10px",
            }}
          >
            <h4>Assign Employees</h4>
            <span> Role Name - {outletName}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
          <input
            className="search-employee mb-3"
            type="text"
            placeholder="Search employees..."
            value={searchQuery}
            onChange={(e) => searchEmployees(e.target.value)}
          />
          <table className="role-tbl">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    // checked={isSelectAll}
                    // onChange={SelectAll}
                    checked={selectAll}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    id="sel-all"
                    className="colored-checkbox"
                  />
                  &nbsp; &nbsp;
                  <label
                    style={{
                      position: "relative",
                      top: "-5px",
                      cursor: "pointer",
                      fontSize: "13px",
                      marginTop: "-15px",
                    }}
                    htmlFor="sel-all"
                  >
                    Select All
                  </label>
                </th>
                <th
                  style={{
                    fontSize: "13px",
                    position: "relative",
                    top: "-2.5px",
                  }}
                >
                  Employee Name
                </th>
                <th
                  style={{
                    fontSize: "13px",
                    position: "relative",
                    top: "-2.5px",
                  }}
                >
                  Web Access
                </th>
                <th
                  style={{
                    fontSize: "13px",
                    position: "relative",
                    top: "-2.5px",
                  }}
                >
                  App Access
                </th>
              </tr>
            </thead>
            <tbody>
              {employeeList.length > 0 ? (
                employeeList.map((row) => (
                  <tr key={row.staffId}>
                    <td>
                      <input
                        type="checkbox"
                        checked={isStaffSelected(row.staffId)}
                        onChange={(e) =>
                          handleSelectIndividual(row.staffId, e.target.checked)
                        }
                        id={"role" + row.staffId}
                        className="colored-checkbox"
                      />
                    </td>
                    <td
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <label
                        style={{ cursor: "pointer", fontSize: "14px" }}
                        htmlFor={"role" + row.staffId}
                      >
                        {row.fullName}
                      </label>
                      <span style={{ fontSize: "12px", color: "gray" }}>
                        {row.empId}
                      </span>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="checkbox"
                        // checked={selectedWebAccess.includes(row.staffId)}
                        // onChange={(e) => selectWebAccess(e, row.staffId)}
                        checked={isChecked(row.staffId, "web")}
                        onChange={(e) =>
                          handleAccessChange(
                            row.staffId,
                            "web",
                            e.target.checked
                          )
                        }
                        id={"shift" + row.staffId}
                        className="colored-checkbox"
                      />
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="checkbox"
                        // checked={selectedAppAccess.includes(row.staffId)}
                        // onChange={(e) => selectAppAccess(e, row.staffId)}

                        checked={isChecked(row.staffId, "mobile")}
                        onChange={(e) =>
                          handleAccessChange(
                            row.staffId,
                            "mobile",
                            e.target.checked
                          )
                        }
                        id={"shift" + row.staffId}
                        className="colored-checkbox"
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">No employees found</td>
                </tr>
              )}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="universal-input-one"
            style={{
              backgroundColor: "#566573",
              color: "#fff",
              marginRight: "5px",
            }}
            onClick={handleModalClose1}
          >
            Cancel
          </Button>
          <Button className="universal-btn" onClick={handleAssignRoleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {/* ------------------------------ */}

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <div className="SettingBody-card mt-3">
        <Widgets
          icon={
            <WidgetsIcon
              icon={
                <Link to="/setting/" className="color-white">
                  <ArrowBackIcon />
                </Link>
              }
              title="Company Roles"
            />
          }
          button={
            HasPermission("Roles", "create") && (
              <ButtonCom
                type={"button"}
                class_name={"p_btn universal-btn"}
                text={"Add Roles"}
                url_or_onclick={handleClickOpen}
                icon={<AddIcon />}
                width={""}
              />
            )
          }
          body={
            <>
              <div
                className="ag-theme-quartz custom-grid mt-2"
                style={{ height: "calc(100vh - 240px)", width: "100%" }}
              >
                <AgGridReact
                  rowData={Array.isArray(roleList) ? roleList : []}
                  columnDefs={heading}
                  omLayout="autoHeight"
                  pagination={true}
                  paginationPageSize={paginationPageSize}
                  onGridReady={onGridReady}
                />
              </div>
              <div className="d-flex align-items-center justify-content-between custom-pagination">
                {gridApi && <CustomPagination gridApi={gridApi} />}
              </div>
            </>
          }
        />
      </div>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle
          style={{ fontSize: "18px", fontWeight: "bold", color: "#fff" }}
        >
          Add New Role
        </DialogTitle>
        <Form
          noValidate
          validated={validated}
          onSubmit={isEdit ? handleEditSubmit : handleSubmit}
        >
          <DialogContent>
            <Row>
              <Col sm="12">
                <Form.Group className="mb-2">
                  <Form.Label className="color-white">Role Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="roleName"
                    value={roles.roleName}
                    placeholder="Enter Role Name"
                    onChange={handelChange}
                    required
                    className="universal-input"
                  />
                  <Form.Control.Feedback type={"invalid"}>
                    Please provide valid role name.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="gray"
              onClick={handleClose}
              style={{
                fontWeight: "300",
                fontSize: "14px",
                height: "30px",
                width: "100px",
                backgroundColor: "gray",
                color: "white",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="info"
              type="submit"
              style={{
                fontWeight: "300",
                fontSize: "14px",
                height: "30px",
                width: "100px",
              }}
              className="universal-btn"
            >
              Save
            </Button>
          </DialogActions>
        </Form>
      </Dialog>
    </div>
  );
};

export default Roles;
